import { render, staticRenderFns } from "./PrimaryRedBag.vue?vue&type=template&id=dfe63362&scoped=true"
import script from "./PrimaryRedBag.vue?vue&type=script&lang=js"
export * from "./PrimaryRedBag.vue?vue&type=script&lang=js"
import style0 from "./PrimaryRedBag.vue?vue&type=style&index=0&id=dfe63362&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe63362",
  null
  
)

export default component.exports